import * as React from 'react';

const SquareSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 21h18V3H3v18zm-1 1h20V2H2v20z"
        />
    </svg>
);

SquareSvg.displayName = 'SquareSvg';
export default SquareSvg;
